module.exports = __webpack_public_path__ + "/images/cover-cta-sophie-chupete-m.ba078cd.jpg";